module.exports = __webpack_public_path__ + "static/media/a-4.498704dd.jpg";